import React, { useState, useEffect } from 'react';
import Input from '../../customs/Input';

export default function SinglePriceInput({ isDelivery, onChangePrice, plans, category }) {
    const [pricePlans, setPricePlans] = useState(() =>
        plans.map((plan) => ({
            plan_name: plan.plan_name,
            profit_margin: "",
            base_price: '',
            customer_price: plan.profit_margin,
            delivery_price: '',
        }))
    );
    const [customerPrices, setCustomerPrices] = useState(pricePlans.map((plan) => (Number(plan.base_price) + Number(plan.profit_margin))));
    const [isDone, setIsDone] = useState(false);
    const [numBasePriceChanges, setNumBasePriceChanges] = useState(0);

    useEffect(() => {
        let componentMount = true
        if (componentMount) {
            setPricePlans(plans)
        }
        return () => {
            componentMount = false;
        };
    }, [plans])

    useEffect(() => {
        setPricePlans(
            plans.map((plan) => ({
                plan_name: plan.plan_name,
                profit_margin: plan.profit_margin,
                base_price: '',
                customer_price: plan.profit_margin,
                delivery_price: '',
            }))
        );
        setIsDone(false);
        setNumBasePriceChanges(0);

        setCustomerPrices(
            plans.map((plan) => Number(plan.profit_margin))
        );
    }, [category, plans]);


    useEffect(() => {
        let done = false;
        pricePlans.forEach((plan) => {
            if (plan.base_price !== '' || plan.delivery_price !== '') {
                done = true;
            }
        });
        setIsDone(done);
    }, [pricePlans]);

    useEffect(() => {
        if (isDone && numBasePriceChanges === plans.length) {
            onChangePrice(category,pricePlans);
        }
    }, [isDone, numBasePriceChanges, pricePlans, onChangePrice, plans,category]);


    const handleBasePriceChange = (index, e) => {
        const newBasePrice = Number(e.target.value);
        const newCustomerPrice = newBasePrice + Number(pricePlans[index].profit_margin);

        // update the customer price state for this plan
        setCustomerPrices(prevPrices => {
            const newPrices = [...prevPrices];
            newPrices[index] = newCustomerPrice;
            return newPrices;
        });

        // update the plans state with the new base price
        setPricePlans(prevPlans => {
            const newPlans = [...prevPlans];
            newPlans[index].base_price = newBasePrice.toString();
            newPlans[index].customer_price = newCustomerPrice.toString();
            return newPlans;
        });
        // increment the count of base_price fields changed
        setNumBasePriceChanges((prevCount) => prevCount + 1);
    }
    const handleDeliveryPriceChange = (index, e) => {
        const newDeliveryPrice = Number(e.target.value);
        setPricePlans(prevPlans => {
            const newPlans = [...prevPlans];
            newPlans[index].delivery_price = newDeliveryPrice.toString();
            return newPlans;
        });
    };

    return (
        pricePlans.map((plan, key) => (
            <div className='row' key={key}>
                <div className='col-sm-4 col-md-4'>
                    <Input
                        type="text"
                        label={`Base price for ${plan.plan_name}`}
                        name={`base_price_${plan.plan_name}`}
                        required={true}
                        handler={(e) => handleBasePriceChange(key, e)}
                        defaultValue={plan.base_price}
                    />
                </div>
                <div className='col-sm-4 col-md-4'>
                    <Input
                        type="text"
                        label={`Customer price for ${plan.plan_name}`}
                        name={`customer_price_${plan.plan_name}`}
                        required={true}
                        defaultValue={customerPrices[key]}
                        readOnly={true}
                        disabled={true}
                    />
                </div>
                <div className='col-sm-4 col-md-4'>
                    <Input
                        type="text"
                        label={`Delivery price for ${plan.plan_name}`}
                        name={`delivery_price_${plan.plan_name}`}
                        required={false}
                        disabled={!isDelivery}
                        handler={(e) => handleDeliveryPriceChange(key, e)}
                    />
                </div>
            </div>
        )));
}